module.exports = __webpack_public_path__ + "static/install-fraud-04f7bb50b5c38c4b519305d8592a4a08.gif";